import { render, staticRenderFns } from "./regStudentDetails.vue?vue&type=template&id=d5f9a820&scoped=true&"
import script from "./regStudentDetails.vue?vue&type=script&lang=js&"
export * from "./regStudentDetails.vue?vue&type=script&lang=js&"
import style0 from "./regStudentDetails.vue?vue&type=style&index=0&id=d5f9a820&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5f9a820",
  null
  
)

export default component.exports